import { abbrNumberFilter } from "app/filters/ngFilters";
import { getRangeChipValue } from "app/pages/sales-intelligence/modules/find-apps-filters/utils";
import type { IFindAppsRange } from "app/pages/sales-intelligence/store/find-apps/types";
import { is } from "app/pages/sales-intelligence/utils/type-guards";

const formatNumber = (value: number): string => abbrNumberFilter()(value) as string;

function formatChipsContent(value: Partial<IFindAppsRange<number>>): string {
    const { from, to } = value || {};

    const formattedFrom = is.undefined(from) ? "" : formatNumber(from);
    const formattedTo = is.undefined(to) ? "" : formatNumber(to);

    return getRangeChipValue({ from: formattedFrom, to: formattedTo }, false);
}

export default formatChipsContent;
